import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "@/utils/ga";

function useAnalyticsPageTracking() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);
}

export default useAnalyticsPageTracking;
